// What the organization turns on or off for each kind's default audience — the members a kind is
// meant for without having asked — beside the platform's own default. Read and changed with
// `tenancy.settings.manage`. A member's own choice always wins over it, and it never reaches anybody
// outside the default audience.

import { api } from '../client'
import type { components } from '../schema'
import type { UpdateNotificationChoices } from './preferences'

export type NotificationDefaults = components['schemas']['NotificationDefaultsView']
export type NotificationKindDefault = components['schemas']['NotificationKindDefault']
export type NotificationChannelDefault = components['schemas']['NotificationChannelDefault']
export type NotificationAudience = components['schemas']['NotificationAudience']

const DEFAULTS = '/orgs/current/notification-defaults'

/**
 * Every kind of the platform, whether or not anybody here may be told of it: each channel's
 * organization default (`null` where it set none), the platform's beside it, and who the default
 * audience is, with the organization's roles that make it up today.
 */
export function readNotificationDefaults(signal?: AbortSignal): Promise<NotificationDefaults> {
  return api.get<NotificationDefaults>(DEFAULTS, undefined, signal)
}

/**
 * Set (`true`, `false`) or clear (`null`, back to the platform's) the organization's defaults, all
 * or none; the answer is the view after the change. 400 for a channel that is not `selectable` yet
 * or a kind and channel named twice, 422 for mail turned off on a mandatory kind.
 */
export function updateNotificationDefaults(body: UpdateNotificationChoices): Promise<NotificationDefaults> {
  return api.patch<NotificationDefaults>(DEFAULTS, body)
}
